import { render, staticRenderFns } from "./InGroupFansDialog.vue?vue&type=template&id=5a828f6c&scoped=true"
import script from "./InGroupFansDialog.vue?vue&type=script&lang=js"
export * from "./InGroupFansDialog.vue?vue&type=script&lang=js"
import style0 from "./InGroupFansDialog.vue?vue&type=style&index=0&id=5a828f6c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a828f6c",
  null
  
)

export default component.exports